(() => {
  const itemSelector = '.haro-primary-nav__item--has-children';
  const closeDelay = 280;

  const bindHoverGrace = (root = document) => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const items = root.matches?.(itemSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(itemSelector) || []);

    items.forEach((item) => {
      if (item.dataset.haroHoverGrace === 'true') return;

      item.dataset.haroHoverGrace = 'true';
      let closeTimer;

      const cancelClose = () => {
        window.clearTimeout(closeTimer);
        closeTimer = undefined;
      };

      item.addEventListener(
        'mouseenter',
        () => {
          cancelClose();

          document.querySelectorAll(itemSelector).forEach((otherItem) => {
            if (otherItem !== item && otherItem.getAttribute('aria-expanded') === 'true') {
              otherItem.hideDisclosure?.();
            }
          });
        },
        true
      );
      item.addEventListener(
        'mouseleave',
        (event) => {
          event.stopImmediatePropagation();
          cancelClose();

          closeTimer = window.setTimeout(() => {
            if (item.matches(':hover') || item.contains(document.activeElement)) return;
            item.hideDisclosure?.();
          }, closeDelay);
        },
        true
      );
    });
  };

  customElements.whenDefined('hover-disclosure').then(() => bindHoverGrace());
  document.addEventListener('shopify:section:load', (event) => bindHoverGrace(event.target));
})();
